class DadosUsuarioModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'api', 'cidadeService', 'cepService', 'userId']

  constructor: ($injector, @modalInstance, @api, @cidadeService, @cepService, userId) ->
    super($injector)

    @loadPromise = @api.get("/usuarios/#{userId}")

    @loadPromise.then(({data}) =>
      @user = data.usuario
      @user.numero = parseInt(@user.numero)
      @old_email = @user.email
    )
    
  buscarCep: (input) ->
    if @user.cep and @user.cep.length is 8
      input.$setValidity('cep', true)
      cep = angular.copy @user.cep
  
      @cepService.buscarCep(cep, (result) =>
        if result.success && result.data
          @user.bairro = result.data.bairro
          @user.endereco = result.data.logradouro
  
          @cidadeService.search({codigo_ibge: result.data.ibge}, (data) =>
            if data.length > 0
              @user.cidade = data[0]
            else
              @user.cidade = result.data.ibge
  
          )
          @user.ibge = result.data.ibge
  
          $('[name="numero"]').focus()
        else
          input.$setValidity('cep', false)
      )

  validateConfirmation: (input, compareTo) ->
    if input.$modelValue != compareTo
      input.$setValidity('confirmation', false)
    else
      input.$setValidity('confirmation', true)

  salvar: (form) ->
    if form.$valid
      user = angular.copy(@user)

      user.cidade_id = user.cidade.id
      user.numero = '' + user.numero

      @api.put("/usuarios/#{user.id}", usuario: user)
        .then(({data}) =>
          @modalInstance.close(data)
        )
        .catch(({data, status}) =>
          if status == 422
            for {field, error} in data.errors
              form[field].$setValidity(error, false)
              form[field].$viewChangeListeners.push(() ->
                form[field].$setValidity(error, true))
          else
            @Alert.error("Um erro ocorreu ao realizar o cadastro deste usuário", "Usuário não foi cadastrado")
        )


angular.module("eficienciaFiscalModule").controller('dadosUsuarioModalController', DadosUsuarioModalController)
